module.exports = __webpack_public_path__ + "static/img/3_v2.3fb93b89.png";